<template>
  <div id="service-2" class="service-section pt-60">
    <div class="container">
      <!-- Başlık kısmı -->
      <div class="row justify-content-center">
        <div class="col-xl-8 col-lg-8">
          <div class="section-title text-up">
            <h2>{{vars.titleText}}</h2>
          </div>
        </div>
        <div class="col-xl-4 col-lg-4 text-start">
          <p> {{vars.descriptionText}}</p>
        </div>
      </div>

      <!-- Accordion -->
      <div class="row">
        <div class="col-xl-12">
          <div class="cp-custom-accordion">
            <div class="accordions" id="accordionExample">
              <!-- v-for ile tek satırda dönüyoruz -->
              <div
                class="accordion-items"
                v-for="(service, index) in services"
                :key="service.id"
              >
                <h2 class="accordion-header" :id="`heading${service.id}`">
                  <button
                    class="accordion-buttons"
                    type="button"
                    data-bs-toggle="collapse"
                    :data-bs-target="`#service${service.id}`"
                    :aria-expanded="index === 0"
                    :aria-controls="`service${service.id}`"
                  >
                   
                    <span style="color: grey;">{{ String(index + 1).padStart(2, '0') }}</span> <h3> {{ service.title }}</h3>
                   
                  </button>
                 </h2>
                <div
                  :id="`service${service.id}`"
                  class="accordion-collapse collapse"
                  :class="{ show: index === 0 }"
                  :aria-labelledby="`heading${service.id}`"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    <img :src="service.photo" alt="" />
                    <p>{{ service.description }}</p>
                  </div>
                </div>
              </div>
         
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
export default defineNuxtComponent({
  mixins: [ComponentMixin],

  data() {
    return {


    };
  },

  computed: {
    descriptions() {
      return this.groupedVariables.descriptions;
    },
    services() {
      return this.groupedVariables.services;
    },
  },

  methods: {
    isExternalLink(url: string) {
      return url.includes('http');
    },
  },
});
</script>
